import { toast } from 'react-toastify';

const notifications = (msg, type = 'error', options) => {
    if(type ==='error'){
        msg = msg || 'Something went wrong!';
        toast.error(msg.toString(), options);
    }
    else if(type==='info')
        toast.info(msg,options);
    else if(type==='success')
        toast.success(msg);    
}

export default notifications;


